import React from 'react';
import PropTypes from 'prop-types';
import {
  LoadingPage,
  LoadingCard,
  Spinner,
  TextGroup,
} from './PageLoadingState.styles';

function PageLoading({
  title = 'Loading...',
  description = 'Getting everything ready for you.',
}) {
  return (
    <LoadingPage>
      <LoadingCard>
        <Spinner aria-label="Loading" />

        <TextGroup>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </TextGroup>
      </LoadingCard>
    </LoadingPage>
  );
}

export default PageLoading;

PageLoading.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};
